const tooltipFormActions = {
  edit: 'edit',
  delete: 'delete',
  equipment: 'Go to equipment details',
  service: 'Go to service details'
};

export default tooltipFormActions;
